<div class="message-list-ordered">
	<div class="text" *ngIf="elements.payload.text.length > 0">{{ elements.payload.text[0] }}</div>
	<ol>
		<li *ngFor="let item of elements.payload.values">{{ item }}</li>
	</ol>
</div>